import { getWithAuth } from '@/api/httpRequests'
import Channel from '@/shared/classes/channels/channel'
import { ChannelProps } from '@/types/tv/channels/Channel'
import { getErrorMessage } from '@/shared/lib/getErrorMessage'
import ConfigRepository from '@/shared/config/repository/configRepository'
import Config from '@/shared/config/config'
import { ITVServiceToya } from '@/shared/services/types/tvService/tvServiceInterfaces'
import {
    removeFromLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'
import { getChannelsRoute } from '@/api/apiConstants'
import { useAppStore } from '@/shared/store'

const configRepository = ConfigRepository.Instance

class TVServiceToya implements ITVServiceToya {
    getFilteredChannelList = (channelsList: ChannelProps[]) => {
        const filteredChannels = channelsList.filter(
            (channel: ChannelProps) => !!channel
        )
        return filteredChannels
    }

    getChannelObjectList = (channels: ChannelProps[]) => {
        const channelObjectsList = channels.map((channel: ChannelProps) => {
            const channelObject = new Channel(channel)
            return channelObject
        })
        return channelObjectsList
    }
    getOttChannels = (channels: Array<Channel>) => {
        const OttChannelsList = channels.filter(
            (channel: Channel) => channel.checkOrigin() === 'OTT'
        )
        return OttChannelsList
    }
    getIptvChannels = (channels: Array<Channel>) => {
        const OttChannelsList = channels.filter(
            (channel: Channel) => channel.checkOrigin() === 'IPTV'
        )
        return OttChannelsList
    }
    getDvbChannels = (channels: Array<Channel>) => {
        const OttChannelsList = channels.filter(
            (channel: Channel) => channel.checkOrigin() === 'DVB'
        )
        return OttChannelsList
    }

    getNoDrmWidevineChannels = (channels: Array<Channel>) => {
        const widevineDrmChannels = channels.filter((channel: Channel) => {
            const { drmType } = channel
            return (
                drmType === 'widevine' ||
                drmType === 'noDrm' ||
                drmType === 'drmFairPlay' ||
                drmType === null
            )
        })
        return widevineDrmChannels
    }

    getWidevineOttChannelList = (rawChannels: Channel[]) => {
        const filteredChannelList = this.getFilteredChannelList(rawChannels)
        const channelObjectList = this.getChannelObjectList(filteredChannelList)
        const ottChannelsList = this.getOttChannels(channelObjectList)
        const filteredNoDrmWidevine =
            this.getNoDrmWidevineChannels(ottChannelsList)

        return filteredNoDrmWidevine
    }

    getApiChannelsList = async (sessionToken: string | null) => {
        const isGuest = useAppStore.getState().isGuest || false
        if (!sessionToken && !isGuest) return undefined

        try {
            const response = await getWithAuth(getChannelsRoute)
            const channelsList = response.channels
            if (channelsList) {
                const widevineOttChannelsList =
                    this.getWidevineOttChannelList(channelsList)
                return widevineOttChannelsList
            }
            return
        } catch (error) {
            getErrorMessage('getApiChannelsList', error)
            removeFromLocalStorage(sessionTokenLsKeyword)
        }

        return
    }
    getWidevineOttChannelsIds = (widevineOttChannelsList: Channel[]) => {
        const idsArray = widevineOttChannelsList.map(
            (channel: Channel) => channel.id
        )
        return idsArray
    }

    getTvChannelsList = (channels: Channel[]) => {
        if (!channels) return []
        const tvChannels = channels.filter(
            (channel: Channel) => channel.service === 1
        )

        return tvChannels
    }

    getRadioChannelsList = (channels: Channel[]) => {
        if (!channels) return []
        const tvChannels = channels.filter(
            (channel: Channel) => channel.service === 2
        )
        return tvChannels
    }

    getGroupedTvRadioChannels = (channels: Channel[]) => {
        const tvChannels = this.getTvChannelsList(channels)
        const radioChannels = this.getRadioChannelsList(channels)
        return tvChannels.concat(radioChannels)
    }

    checkIfChannelsVersionChanged = async (
        previousLocalConfig: Config | null | undefined
    ) => {
        if (!previousLocalConfig) return false
        const newConfig = configRepository.getLocalConfig()
        if (newConfig) {
            return (
                previousLocalConfig.channelsVersion !==
                newConfig.channelsVersion
            )
        }
    }
}

export default new TVServiceToya()
